export const ARTICLE_LOADED = 'News/Content/ARTICLE_LOADED';
export const REQUESTING_ARTICLE = 'News/Content/REQUESTING_ARTICLE';
export const LOAD_NEWS_DIRECTORY = 'News/Content/LOAD_NEWS_DIRECTORY';

export const ITEM_NOT_FOUND = 'ITEM_NOT_FOUND';
export const NEWS_DIRECTORY_SLUG = 'default';
export const NEWS_TRENDING_SLUG = 'trending';
